import React, { useEffect } from "react";
import gsap from "gsap";
import './loader.css'

function Preloader({ setLoading }) {
  useEffect(() => {
    const tl = gsap.timeline({
      onComplete: () => setLoading(false),
    });

    tl.to(".preloader-text", { opacity: 0, duration: 0.5 }, "+=1.5") 
      .to(".preloader-top", { y: "-100%", duration: 1.5, ease: "power4.inOut" }, "-=0.5") 
      .to(".preloader-bottom", { y: "100%", duration: 1.5, ease: "power4.inOut" }, "-=1.5")
      .to(".main-content", { opacity: 1, duration: 0.5 }, "-=1"); // Show website just before animation ends
  }, [setLoading]);

  return (
    <div className="preloader">
      <div className="preloader-half preloader-top"></div>
      <div className="preloader-half preloader-bottom"></div>
      <h1 className="preloader-text">
      <div class="loader">
<div class="loader-square"></div>
<div class="loader-square"></div>
<div class="loader-square"></div>
<div class="loader-square"></div>
<div class="loader-square"></div>
<div class="loader-square"></div>
<div class="loader-square"></div>
</div>
      </h1>
    </div>
  );
}

export default Preloader;

